<template>
    <div class="scale-wrapper">
        <div class="vertical-scale">
            <div class="scale-label content-label" :class="getDisabledClasses(disabled)">£'000</div>
            <div v-for="label in labels" :key="label.value" :style="getPositionStyle(label.value)" class="scale-label"
                :class="getDisabledClasses(disabled)">
                {{ label.text }}
            </div>
        </div>
    </div>
</template>
  
<script setup lang="ts">
import { computed } from 'vue';
import { tickCount, tickUnits, getDisabledClasses } from "@/guiide/ts/wants/wantsUtilities";
import { roundUpToNearest } from "../../ts/utilities";

const props = defineProps({
    maxValue: Number,
    step: { type: Number, default: 10000 },
    disabled: { type: Boolean, default: false }
});

type Label = { value: number, text: string };

const labels = computed<Array<Label>>(() => {
    const unit = roundUpToNearest(props.maxValue / tickCount, tickUnits);
    const ticks = props.maxValue / unit;
    return Array.from({ length: ticks + 1 }, (_, i) => (i * unit)).map(v => { return { value: v, text: (v / 1000).toString() } as Label });
});

const getPositionStyle = (labelValue: number) => {
    const positionPercentage = (labelValue / props.maxValue) * 100;
    const baseTweak = 2;
    const positionTweak = (positionPercentage / 100) * 5;
    const tweak = baseTweak + positionTweak;
    const bottom = positionPercentage - tweak;
    return { bottom: `${bottom}%` };
};
</script>
  
<style scoped>
.scale-wrapper {
    height: 92%;
    display: flex;
    flex-direction: row;
    text-align: start;
}

.vertical-scale {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
    width: 41px;
    margin-right: 4px;
}

.scale-label {
    position: absolute;
    right: 0;
    text-align: center;
}

.content-label {
    transform: rotate(-90deg);
    bottom: 48%;
    right: 5px;
    width: 60px;
}

.disabled {
    opacity: 0.65;
}
</style>
  